<form class="form-inline">
    <div class="form-group m-0">
        <div class="input-group date-range-picker-input">
            <i class="fn-global-calendar pe-none"></i>
            <input name="datepicker" class="form-control input-round" ngbDatepicker #datepicker="ngbDatepicker" [autoClose]="'outside'" [displayMonths]="2" [dayTemplate]="dayTemplate" [footerTemplate]="footerTemplate" outsideDays="hidden" [startDate]="fnStartDate" (dateSelect)="onDateSelection($event)" (closed)="setDefaultDate()" (click)="openDatePicker(datepicker)" [value]="uiDateValue"
                   [minDate]="fnMinDate" [maxDate]="fnMaxDate" [markDisabled]="isDisbled" container="{{ container }}" (closed)="onClosed()" readonly>
            <i class="fn-global-expand drop" (click)="openDatePicker(datepicker)"></i>
            <ng-template #dayTemplate let-date let-focused="focused">
                <span [class.focused]="focused" [class.focused]="focused" [class]="getDateClass(date)" [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                    {{ date.day }}
                </span>
            </ng-template>
            <ng-template #footerTemplate>
                <div class="row m-0 daterange-footer">
                    <div class="col-12 p-0">
                        <button class="btn-round btn-danger btn btn-xs pull-left float-left width-80px" type="button" (click)="resetDate(datepicker)">Cancel</button>
                        <button class="btn-round btn btn-xs pull-right btn-success float-right  width-80px" type="button" (click)="submit(datepicker)">Apply</button>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</form>
